import React, { useEffect, useState } from "react";
import axios from "axios";
import { Checkbox, Select, Spin, Divider, Typography, message } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";

const { Text } = Typography;

const CAMPOS = [
  { key: "descripcion", label: "Descripción" },
  { key: "descripcionLarga", label: "Descripción larga / detalles" },
  { key: "clave", label: "Clave" },
  { key: "codigo", label: "Código" },
  { key: "codigoBarras", label: "Código de barras" },
  { key: "marca", label: "Marca" },
  { key: "tipo", label: "Tipo de insumo" },
  { key: "familia", label: "Familia" },
  { key: "unidad", label: "Unidad" },
];

const FORMATO_OPCIONES = [
  { value: "none", label: "Normal" },
  { value: "bold", label: "Negrita" },
  { value: "italic", label: "Itálica" },
  { value: "strike", label: "Tachado" },
];

// Configura qué campos vienen marcados por defecto y con qué formato (negrita/itálica/tachado).
const CamposDefaultInsumo = ({ headersToken, empresaId }) => {
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [campos, setCampos] = useState([]);
  const [precios, setPrecios] = useState([]);
  const [incluirImagen, setIncluirImagen] = useState(true);
  const [formatos, setFormatos] = useState({});
  const [listasPrecios, setListasPrecios] = useState([]);

  const headers = { headers: headersToken };

  useEffect(() => {
    axios
      .post("whatsapp/obtenerPreferenciasInsumo", { empresaId }, headers)
      .then((r) => {
        if (r.data.success === 2) {
          setCampos(r.data.preferencias.campos || []);
          setPrecios(r.data.preferencias.precios || []);
          setIncluirImagen(r.data.preferencias.incluirImagen !== false);
          setFormatos(r.data.preferencias.formatos || {});
          setListasPrecios(r.data.listasPrecios || []);
        }
      })
      .catch(() => message.error("Error de red al cargar las preferencias."))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = (lista, setter, valor) =>
    setter(lista.includes(valor) ? lista.filter((v) => v !== valor) : [...lista, valor]);

  const setFormato = (key, valor) => setFormatos((prev) => ({ ...prev, [key]: valor }));

  const selectorFormato = (key) => (
    <Select
      size="small"
      style={{ width: 120 }}
      value={formatos[key] || "none"}
      onChange={(v) => setFormato(key, v)}
      options={FORMATO_OPCIONES}
    />
  );

  const guardar = () => {
    setGuardando(true);
    axios
      .post("whatsapp/guardarPreferenciasInsumo", { campos, precios, incluirImagen, formatos }, headers)
      .then((r) => {
        if (r.data.success === 2) message.success("Preferencias guardadas.");
        else message.error(r.data.message || "No se pudo guardar.");
      })
      .catch(() => message.error("Error de red al guardar."))
      .finally(() => setGuardando(false));
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 20 }}>
        <Spin />
      </div>
    );
  }

  return (
    <div>
      <Text type="secondary">
        Elige qué campos vienen marcados por defecto al crear un “Detalle de insumo” y con qué
        formato (WhatsApp lo muestra en negrita, itálica o tachado). Las categorías especiales se
        excluyen de los marcados por defecto porque varían en cada insumo.
      </Text>

      <Divider orientation="left" plain style={{ margin: "14px 0 8px" }}>
        Campos
      </Divider>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {CAMPOS.map((c) => (
          <div
            key={c.key}
            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", maxWidth: 400, gap: 12 }}
          >
            <Checkbox checked={campos.includes(c.key)} onChange={() => toggle(campos, setCampos, c.key)}>
              {c.label}
            </Checkbox>
            {selectorFormato(c.key)}
          </div>
        ))}
      </div>

      {listasPrecios.length > 0 && (
        <>
          <Divider orientation="left" plain style={{ margin: "14px 0 8px" }}>
            Precios
          </Divider>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 16px" }}>
            {listasPrecios.map((nombre) => (
              <Checkbox
                key={nombre}
                checked={precios.includes(nombre)}
                onChange={() => toggle(precios, setPrecios, nombre)}
              >
                {nombre}
              </Checkbox>
            ))}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
            <Text>Formato de precios:</Text>
            {selectorFormato("precios")}
          </div>
        </>
      )}

      <Divider orientation="left" plain style={{ margin: "14px 0 8px" }}>
        Categorías especiales
      </Divider>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Text>Formato (cuando se incluyan):</Text>
        {selectorFormato("categorias")}
      </div>

      <Divider orientation="left" plain style={{ margin: "14px 0 8px" }}>
        Imagen
      </Divider>
      <Checkbox checked={incluirImagen} onChange={(e) => setIncluirImagen(e.target.checked)}>
        Incluir imagen del insumo por defecto
      </Checkbox>

      <div style={{ marginTop: 16, textAlign: "right" }}>
        <ButtonItem cyan icon={<SaveOutlined />} loading={guardando} onClick={guardar}>
          Guardar preferencias
        </ButtonItem>
      </div>
    </div>
  );
};

export default CamposDefaultInsumo;
